<section class="new-code">
    <p class="font-light">Enter the discount code you received and it will be available for your next purchase if applicable.</p>
    <br/>
    <form class="code-entry" [formGroup]="couponEntry" (submit)="submit()">
        <mat-icon>card_giftcard</mat-icon>
        <input formControlName="code" class="font-light" matInput type="text" autocomplete="off"/>
        @if(error()){
            <mat-error>{{error()}}</mat-error>
        } @else {
            <mat-hint>&nbsp;</mat-hint>
        }
        <div class="button">
            <button mat-flat-button class="package-button font-bold" paint="plan-bg" [disabled]="service.loading() || !couponEntry.valid">
                @if(service.loading()){
                    <mat-icon class="rotating sized mr-0i" style="--icon-size: 24px;">autorenew</mat-icon>
                } @else {
                    Apply
                }
            </button>
        </div>
    </form>
</section>
<div class="spacer"></div>
<section class="unused used">
    <h3 class="font-bold" (click)="showUnused.set(!showUnused())">
        <span [class.not-shown]="!showUnused()">Unused codes ({{unused().length || 0}})</span> 
        <button class="view font-bold">{{!showUnused() ? 'VIEW' : 'HIDE'}}</button>
    </h3>
    <section class="codes" [@dissolve]="showUnused()">
        @if(!unused().length){
            <p class="font-light">No unused codes</p>
        } @else {
            @for(use of unused(); track use._id){
                @let coupon = use.coupon;
                @let pkg = packages()[coupon.package] || { short_name: ''};
                <div class="code">
                    <div>
                        <div>
                            <h4 class="font-bold"><span>{{coupon.title}}</span></h4>
                            <h3 class="font-bold">
                                {{coupon.percentage ?
                                    coupon.reduction.toFixed(0) + '% OFF '
                                    :
                                    '€' + coupon.reduction.toFixed(2) + ' OFF '
                                }}
                                {{pkg.short_name || 'Premium'}}
                            </h3>
                        </div>
                        <div>
                            <a mat-stroked-button class="font-bold" [routerLink]="['/checkout']" [queryParams]="{ code: use.code}">USE NOW</a>
                            <p class="m-0 font-bold" [paint]="pkg.plan_details?.color_settings?.background??'warn'">{{pkg.short_name}}</p>
                        </div>
                    </div>
                    <br/>
                    <p class="font-light">Code: {{use.code}}</p>
                    <small class="font-light">
                        Generated on: {{use.assigned | date: 'mediumDate'}}
                        @if(use.expiry){
                        | Expires on {{use.expiry | date: 'mediumDate'}}
                        }
                </small>
                </div>
            }
        }
    </section>
</section>
<div class="spacer"></div>
<section class="used">
    <h3 class="font-bold" (click)="showUsed.set(!showUsed())">
        <span [class.not-shown]="!showUsed()">Used codes ({{used().length || 0}})</span> 
        <button class="font-bold view">{{!showUsed() ? 'VIEW' : 'HIDE'}}</button>
    </h3>
    <section class="codes" [@dissolve]="showUsed()">
        @if(!used().length){
            <p class="font-light">No used codes</p>
        } @else {
            @for(use of used(); track use._id){
                @let coupon = use.coupon;
                @let pkg = packages()[coupon.package] || { short_name: ''};
                <div class="code">
                    <div>
                        <div>
                            <h4 class="font-bold"><span>{{coupon.title}}</span></h4>
                            <h3 class="font-bold">
                                {{!coupon.percentage ? '€' : ''}}{{coupon.reduction % 1 == 0 ? coupon.reduction.toFixed(0) : coupon.reduction.toFixed(2)}}{{coupon.percentage ? '%' : ''}} OFF {{pkg.short_name || 'Premium'}}
                            </h3>
                        </div>
                        <div>
                            <button mat-stroked-button rounded class="font-bold" paint="dark" [disabled]="true">USED</button>
                            <p class="m-0 font-bold" [paint]="pkg.plan_details?.color_settings?.background??'warn'">{{pkg.short_name}}</p>
                        </div>
                    </div>
                    <br/>
                    <p class="font-light">Code: {{use.code}}</p>
                    <small class="font-light">Generated on: {{use.created | date: 'mediumDate'}} | Used on {{use.used | date: 'mediumDate'}}</small>
                </div>
            }
        }
    </section>
</section>
<div class="spacer"></div>
<section class="used expired">
    <h3 class="font-bold" (click)="showExpired.set(!showExpired())">
        <span [class.not-shown]="!showExpired()">Expired codes ({{expired().length || 0}})</span> 
        <button class="view font-bold">{{!showExpired() ? 'VIEW' : 'HIDE'}}</button>
    </h3>
    <section class="codes" [@dissolve]="showExpired()">
        @if(!expired().length){
            <p class="font-light">No expired codes</p>
        } @else {
            @for(use of expired(); track use._id){
                @let coupon = use.coupon;
                @let pkg = packages()[coupon.package] || { short_name: '' };
                <div class="code">
                    <div>
                        <div>
                            <h4 class="font-bold"><span>{{coupon.title}}</span></h4>
                            <h3 class="font-bold">
                                {{!coupon.percentage ? '€' : ''}}{{coupon.reduction % 1 == 0 ? coupon.reduction.toFixed(0) : coupon.reduction.toFixed(2)}}{{coupon.percentage ? '%' : ''}} OFF {{pkg.short_name || 'Premium'}}
                            </h3>
                        </div>
                        <div>
                            <button mat-stroked-button rounded class="font-bold" paint="dark" [disabled]="true">EXPIRED</button>
                            <p class="m-0 font-bold" [paint]="pkg.plan_details?.color_settings?.background??'warn'">{{pkg.short_name}}</p>
                        </div>
                    </div>
                    <br/>
                    <p class="font-light">Code: {{use.code}}</p>
                    <small class="font-light">Generated on: {{use.created | date: 'mediumDate'}} | Expired on {{use.expiry | date: 'mediumDate'}}</small>
                </div>
            }
        }
    </section>
</section>
<div class="spacer"></div>

<!-- !Confirm Popup -->

<ng-template #popupBody let-options>
    <div class="action-list p-10">
        @for(option of options; track option.title){
            <div class="action-box p-8" [style.--action-color]="option.color">
                <h3 class="m-0">{{option.title}}</h3>
                <p class="m-0 pt-6">{{option.text}}</p>
                <small class="m0 pb-6">{{option.disclaimer}}</small>
                <br/>
                <br/>
                <button mat-flat-button class="full-width" [mat-dialog-close]="option.prompt_answer">{{option.button}}</button>
            </div>
        }
    </div>
</ng-template>